module.exports = __webpack_public_path__ + "img/7.31f6bc41.png";